import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import vueScrollBehavior from 'vue-scroll-behavior'

Vue.use(Router)
Vue.use(Meta)

import Home        from './views/Home.vue'
import Creator     from './views/Creator.vue'
import Entry       from './views/Entry.vue'
import Privacy     from './views/Privacy.vue'
import Terms       from './views/Terms.vue'
import Contact     from './views/Contact.vue'
import Auth        from './views/Auth.vue'
import Blog        from './views/Blog.vue'
import Unpublished from './views/Unpublished.vue'
import Post        from './views/Post.vue'
import Recrop      from './views/Recrop.vue'
import Settings    from './views/Settings.vue'
import Community   from './views/Community.vue'

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '*',
            redirect: '/'
        },
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: Privacy
        },
        {
            path: '/terms',
            name: 'terms',
            component: Terms
        },
        {
            path: '/contact',
            name: 'contact',
            component: Contact
        },
        {
            path: '/auth',
            name: 'auth',
            component: Auth
        },
        {
            path: '/creator/:id',
            name: 'creator',
            component: Creator,
            props: true
        },
        {
            path: '/entry/:id',
            name: 'entry',
            component: Entry,
            props: true
        },
        {
            path: '/blog',
            name: 'blog',
            component: Blog
        },
        {
            path: '/post/:id',
            name: 'post',
            component: Post,
            props: true
        },
        {
            path: '/blog/drafts',
            name: 'unpublished',
            component: Unpublished
        },
        {
            path: '/recrop',
            name: 'recrop',
            component: Recrop
        },
        {
            path: '/settings',
            name: 'settings',
            component: Settings
        },
        {
            path: '/community-guidelines',
            name: 'community',
            component: Community
        },
    ]
})

router.afterEach((to, from) => {
    localStorage.setItem('previousRoute', from.fullPath)
})

Vue.use(vueScrollBehavior, {
    router: router
})

export default router
